module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Mirror-d8cda922728a49f692e97bbffd27f558.svg";